// Chat plan-change proposals (2026-10-25, backend CHAT_PLAN_PROPOSALS). The coach PREPARES a change; the athlete sees
// the exact change on a card and approves it explicitly — the only way a chat change is written. These are thin
// clients for the backend's card API; nothing here calls an AI service.

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://claude-coach-backend-1.onrender.com';
export const POLL_MS = 3000;
// 2026-10-27: the backend is the only source of a proposal's outcome. The watch covers its slowest generation (~9.5
// min); at the limit the card says it is still being prepared — never a client-made 'failed' (a late success turned
// pending on the server while the card said it failed).
export const POLL_MAX_MS = 10 * 60 * 1000;
export const STILL_PREPARING = 'still_preparing';  // client-only, neutral: the watch stopped, the server decides
export const STILL_PREPARING_HE = "הכנת ההצעה נמשכת זמן מה. אפשר לחזור לצ'אט מאוחר יותר כדי לבדוק את מצבה.";
// The states a card is resumed in after a history load / refresh: still being prepared or awaiting approval.
export const RESUMABLE_PROPOSAL_STATUSES = ['processing', 'pending'];

async function readJson(res) {
  if (!res || !res.ok) {
    const err = new Error(`proposal request ${res ? res.status : 'failed'}`);
    err.status = res ? res.status : 0;
    throw err;
  }
  return res.json();
}

export const fetchProposal = (fetcher, uid, id) =>
  fetcher(`${API_BASE_URL}/chat/plan-proposals/${encodeURIComponent(id)}?user_id=${encodeURIComponent(uid)}`).then(readJson);

export const fetchOpenProposal = (fetcher, uid) =>
  fetcher(`${API_BASE_URL}/chat/plan-proposals/open?user_id=${encodeURIComponent(uid)}`).then(readJson);

export const approveProposal = (fetcher, uid, id) =>
  fetcher(`${API_BASE_URL}/chat/plan-proposals/${encodeURIComponent(id)}/approve?user_id=${encodeURIComponent(uid)}`,
    { method: 'POST' }).then(readJson);

export const rejectProposal = (fetcher, uid, id) =>
  fetcher(`${API_BASE_URL}/chat/plan-proposals/${encodeURIComponent(id)}/reject?user_id=${encodeURIComponent(uid)}`,
    { method: 'POST' }).then(readJson);

/** Poll a proposal while it is being prepared. onUpdate(view) on every change; stops at a final state from the
 *  server, at the limit (reports the neutral {status:'still_preparing'} — never 'failed', never a success), or when
 *  `signal` aborts (Coach closed). */
export function watchProposal({ fetcher, uid, id, onUpdate, signal, now = () => Date.now() }) {
  const t0 = now();
  let timer = null;
  const stop = () => { if (timer) clearTimeout(timer); timer = null; };
  if (signal) signal.addEventListener('abort', stop);
  const tick = async () => {
    if (signal && signal.aborted) return;
    let view = null;
    try { view = await fetchProposal(fetcher, uid, id); } catch { view = null; }
    if (signal && signal.aborted) return;
    if (view && view.status !== 'processing') { onUpdate(view); return; }
    if (now() - t0 >= POLL_MAX_MS) {
      onUpdate({ proposal_id: id, status: STILL_PREPARING, message: STILL_PREPARING_HE });
      return;
    }
    timer = setTimeout(tick, POLL_MS);
  };
  timer = setTimeout(tick, POLL_MS);
  return stop;
}
